import { useEffect } from "react";
import "../Stylesheets/Dashboard/Dashboard.css";
import axios from "axios";
import {Person} from "react-bootstrap-icons";
import { useState } from "react";

const Dashboard = () => {
    const [data, setData] = useState({
        "users": 0,
        "vehicles": 0,
        "bids": 0,
        "history": 0,
        "copart_logins": 0,
        "iaai_logins": 0,
        "accounts": {
            "copart": 0,
            "iaai": 0
        }
    });
    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        axios.get("/api/extension/v1/dashboard")
            .then(res => {
                setData(res.data.data);
            })
            .catch(err => {

            })

        axios.get("/api/extension/v1/alerts")
            .then(res => {
                setAlerts(res.data.data);
            })
            .catch(err => {

            })
    }, [])

    return(
        <div className="page-content-container">
            <h2 className="page-title">Dashboard</h2>
            <div className="dashboard-cards-container">
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Users</h3>
                    </div>
                    <p className="dashboard-card-value">{data.users}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Won Cars</h3>
                    </div>
                    <p className="dashboard-card-value">{data.vehicles}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Bids Count</h3>
                    </div>
                    <p className="dashboard-card-value">{data.bids}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Actions Count</h3>
                    </div>
                    <p className="dashboard-card-value">{data.history}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Copart Login</h3>
                    </div>
                    <p className="dashboard-card-value">{data.copart_logins}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">IAAI Login</h3>
                    </div>
                    <p className="dashboard-card-value">{data.iaai_logins}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">Copart Accounts</h3>
                    </div>
                    <p className="dashboard-card-value">{data.accounts.copart}</p>
                </div>
                <div className="dashboard-card">
                    <div className="dashboard-card-header">
                        <Person size={30} style={{color: "#afb9cf"}}/>
                        <h3 className="dashboard-card-title">IAAI Accounts</h3>
                    </div>
                    <p className="dashboard-card-value">{data.accounts.iaai}</p>
                </div>
            </div>

            <div className="dashboard-alerts-container">
                <h2 className="page-title" style={{marginTop: "50px", marginBottom: "30px"}}>Messages</h2>
                <div className="dashboard-alerts-cards-container">
                    {
                        alerts.map((alerts, index) => (
                            <div key={index} className="dashboard-alert-card" style={{borderLeft: `5px solid ${alerts.alert_type}`, paddingLeft: "20px"}}>
                                <h3 className="dashboard-alert-card-title" style={{color: alerts.alert_type}}>{alerts.title}</h3>
                                <p className="dashboard-alert-card-message">{alerts.html}</p>
                            </div>
                        ))
                    }
                    {
                        alerts.length == 0 &&
                        <p style={{color: "#6c757d"}}>No messages</p>
                    }
                </div>
            </div>
        </div>
    )
}

export default Dashboard